import { AltitudeMenu } from "./components/AltitudeMenu.js";
import { SpeedMenu } from "./components/SpeedMenu.js";
import { HeadingMenu } from "./components/HeadingMenu.js";
import { XResMenu } from "./components/XResMenu.js";
import { RouteMenu } from "./components/RouteMenu.js";
import { HoldMenu } from "./components/HoldMenu.js";
import { FreeTextMenu } from "./components/FreeTextMenu.js";
import { PreviousRouteMenu } from "./components/PreviousRouteMenu.js";
export const aircraftMenuList = [
    "ALTITUDE_MENU",
    "SPEED_MENU",
    "HEADING_MENU",
    "FREETEXT_MENU",
    "X_RES_MENU",
    "ROUTE_MENU",
    "HOLD_MENU",
    "PREV_ROUTE_MENU",
];
export const AircraftMenuComponentMap = {
    ALTITUDE_MENU: AltitudeMenu,
    SPEED_MENU: SpeedMenu,
    HEADING_MENU: HeadingMenu,
    FREETEXT_MENU: FreeTextMenu,
    X_RES_MENU: XResMenu,
    ROUTE_MENU: RouteMenu,
    HOLD_MENU: HoldMenu,
    PREV_ROUTE_MENU: PreviousRouteMenu,
};
//# sourceMappingURL=aircraftMenu.js.map